import React from 'react';

import HeaderLogin from 'components/Header/HeaderLogin';
import Bottom from 'components/Bottom';
import ContentLogin from './ContentLogin';

import './style.scss';

const Login = () => {
  return (
    <div className="login-container d-flex flex-column">
      <HeaderLogin />
      <ContentLogin />
      <Bottom />
    </div>
  );
};

export default Login;
